// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xxsmall-superElipse-9abae493","strokeWidth":"super-ellipse-skins-xxsmall-strokeWidth-f51ee16a"};